

export default function validateTime( field ) {
  const formGroup = field.parentElement.parentElement;

  if ( field.value ) {
    formGroup.classList.remove( 'form-group--has-danger' );
    return true;
  }

  formGroup.classList.add( 'form-group--has-danger' );
  return false;
}
